import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColumnCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { COLUMN_CHART } from "../../../../Data/Charts/ApexChart";

const ColumnChart = () => {
  return(
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={ColumnCharts} />
        <CardBody>
          <div id="column-chart">
            <Chart options={COLUMN_CHART} series={COLUMN_CHART.series} type="bar" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
};

export default ColumnChart;
